import { DropdownPrimeReact, InputCurrencyGroup } from "@finanedi.es/storybook"
import { DeclaracionModelo390DtoProps } from "api/DTOs/DeclaracionModelo390Dto"
import { TIPO_PRORRATA_MODELO_390_ENUM } from "api/Types/TipoProrrataModelo390"
import { InputText } from "primereact/inputtext"
import { UseFormSetValue } from "react-hook-form"
import { FieldTemplateOne } from "../../../PlantillasBloquesTabla"

const ActivityTemplate = ({
  text,
  fields,
  values,
  setValue,
  prefix,
}: {
  text: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: FieldTemplateOne[]
  values: $TSMigrationFixMe
  setValue: UseFormSetValue<DeclaracionModelo390DtoProps>
  prefix: string
}) => {
  const options = [
    { label: "G", value: TIPO_PRORRATA_MODELO_390_ENUM.G },
    { label: "E", value: TIPO_PRORRATA_MODELO_390_ENUM.E },
  ]
  return (
    <div className='tw-p-4 tw-mb-4 tw-bg-white tw-border-2 tw-border-gray-200 tw-rounded-md'>
      <p className='tw-font-medium tw-text-sm'>{text}</p>
      <div className='tw-w-full tw-grid tw-grid-cols-3 tw-pt-3 tw-gap-5'>
        {fields.map((field: FieldTemplateOne) => {
          const fieldName = `${prefix}${field.code}`
          const fieldValue = values?.[`${prefix}${field.code}`]
          return (
            <>
              <div className='tw-col-span-1 tw-flex tw-flex-col'>
                <span className='tw-text-xs tw-text-left'>{field.label}</span>
                {field.inputNumber === "114" ? (
                  <>
                    <div className='p-inputgroup tw-flex-1'>
                      <span className='p-inputgroup-addon !tw-h-10 tw-text-sm'>
                        {field.inputNumber}
                      </span>
                      <div className='!tw-w-full'>
                        <InputText
                          className='!tw-w-full !tw-h-10 tw-text-sm'
                          value={
                            typeof fieldValue === "string" ? fieldValue : ""
                          }
                          onChange={(e) =>
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            setValue(fieldName as any, e.target.value)
                          }
                          disabled={field.disabled ?? false}
                        />
                      </div>
                    </div>
                  </>
                ) : field.inputNumber === "117" ? (
                  <>
                    <div className='p-inputgroup tw-flex-1'>
                      <span className='p-inputgroup-addon !tw-h-10 tw-text-sm'>
                        {field.inputNumber}
                      </span>
                      <div className='!tw-w-full'>
                        <DropdownPrimeReact
                          value={fieldValue}
                          options={options}
                          optionLabel='label'
                          optionValue='value'
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          onChange={(e) => setValue(fieldName as any, e.value)}
                          placeholder='Selecciona'
                          className='!tw-w-full !tw-h-10 !tw-text-sm'
                          panelClassName='tw-rounded-md'
                          aria-label={field.label}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <InputCurrencyGroup
                    suffix={field.inputNumber === "118" ? "%" : "€"}
                    value={fieldValue ?? 0}
                    placeholder='0,00'
                    className='tw-h-full tw-text-sm'
                    numberGroup={String(field.inputNumber)}
                    disabled={field.disabled ?? false}
                    onChange={(value: number | undefined) =>
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      setValue(fieldName as any, value || 0)
                    }
                  />
                )}
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}

export default ActivityTemplate
